import React, { useContext } from "react";
import "./UpdateBody.css";
import { storageData } from "services/Services";
import { useDriverHHM } from "components/StraightThroughHouseholdComp/HouseholdContext/DriverHHMContext";

const UpdateBody = ({ requestContext, endorsementType }) => {
  var driverHHMContext = useDriverHHM();
  var driverHHM = driverHHMContext.driverHHM;

  const changeContext = useContext(requestContext);
  var response = storageData.getItem("responseData");
  response = JSON.parse(response);

  const downloadPdf = (pdfBytes, fileName) => {
    const pdf = `data:application/octet-stream;base64,${pdfBytes}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = pdf;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const blIsDriver =
  (driverHHM?.driverInfo?.licenseStatus == 'Valid' ||
    driverHHM?.driverInfo?.licenseStatus == 'Valid Pennsylvania License') &&
  driverHHM?.driverInfo?.ownInsurance === "0";

  var type = "";

  if(driverHHM?.componentTracker != "Add Driver" ){
    if(blIsDriver){
      type = "New Driver";
    }
    else{
      if(driverHHM?.editType == "No longer resides in household."){
        type = driverHHM?.componentTracker == "Update Driver"? "Updated Driver":"Updated Household Member";
      }
      else{
        if(driverHHM?.componentTracker == "Update Driver"){
          type = "New Household Member";
        }
        else if (driverHHM?.componentTracker == "Add Household Member"){
          type = "New Household Member";
        }
        else{
          type = "New Driver";
        }
      }
    }
  }
  else{
    type = "New Driver";
  }

  return (
    <div className="container">
      {/* Requested Effective Date */}
      <div className="row justify-content-center mb-3">
        <div className="col-12 text-center">
          <p className="fw-bold m-0">
            Change Requested Effective Date:
            <span className="ms-1 text-primary">
            {response?.effectiveDate || new Intl.DateTimeFormat("en-US").format(new Date())}
            </span>
          </p>
        </div>
      </div>

      <div className="row justify-content-center my-3">
        <div className="col-12 text-center">
          <p className="fw-bold m-0" style={{ paddingBottom: 15 }}>
            The following change(s) has been processed:
          </p>

          {/* Household Member / Driver */}
          {/* Driver / Household Member */}
          {driverHHM.userInfo?.firstName && (
            <div className="row justify-content-center mb-2">
              <div className="col-md-5 d-flex">
                <span className="fw-bold text-start" style={{ width: "50%" }}>
                  {type}
                </span>
                <span
                  className="ms-3 text-primary fw-bold text-start"
                  style={{ width: "50%" }}
                >
                  {driverHHM.userInfo?.middleInitial
                    ? `${driverHHM.userInfo.firstName} ${driverHHM.userInfo.middleInitial}. ${driverHHM.userInfo.lastName}`
                    : `${driverHHM.userInfo.firstName} ${driverHHM.userInfo.lastName}`}
                </span>
              </div>
            </div>
          )}
          {/* Address Change */}
          {endorsementType === "Change Address" && (
            <div className="row justify-content-center">
              <div className="col-md-5 d-flex">
                <span className="fw-bold text-start" style={{ width: "50%" }}>
                  New Address
                </span>
                <span
                  className="ms-3 text-primary fw-bold text-start"
                  style={{ width: "50%" }}
                >
                  {`${changeContext?.addressChangeClass?.newAddress?.homeAddress}`}{" "}
                  <br />
                  {`${changeContext?.addressChangeClass?.newAddress?.city},${
                    changeContext?.addressChangeClass?.newAddress?.aptNumber
                      ? " " +
                        changeContext?.addressChangeClass?.newAddress?.aptNumber
                      : ""
                  } ${changeContext?.addressChangeClass?.policyState} ${
                    changeContext?.addressChangeClass?.newAddress?.zip
                  }`}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Download ID Card and Dec Page */}
      <div className="row justify-content-center my-3">
        <div className="col-12 text-center">
          <p className="fw-bold m-0">
            Download your new ID card(s) and declarations page below.
          </p>
          <span className="ms-1 text-primary fw-bold text-decoration-underline">
            <a
              onClick={() =>
                downloadPdf(
                  response?.idCardPdfBytes,
                  `${changeContext.userData?.policyNumber} - ID Card.pdf`
                )
              }
            >
              ID Card
            </a>
          </span>
          <br />
          <span className="ms-1 text-primary fw-bold text-decoration-underline">
            <a
              onClick={() =>
                downloadPdf(
                  response?.declarationsPagePdfBytes,
                  `${changeContext.userData?.policyNumber} - Declarations Page.pdf`
                )
              }
            >
              Declarations Page
            </a>
          </span>
        </div>
      </div>

      <div className="row justify-content-center my-4">
        <div className="col-12 text-center">
          <p className="fw-bold m-0">
            You’ll receive an email in the next 1 to 2 hours with a confirmation
            of your policy update and a breakdown of your new 6-month term cost.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UpdateBody;
